import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';
import style from './style.scss';
import { Radio, Tooltip } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import { ze } from 'utils/zhEn';
import WrappedTipsIcon from 'components/antd-extension/WrappedTipsIcon.jsx';
import { ix } from 'utils/i18n-with-context';

/**
 * 选择按小时和累计数据
 */
const DataTypeSelect = ({
  handleDataTypeChange,
  handleGranularityChange,
  enableTenMinuteTrend,
  realTimeGranularity,
  searchParams,
  reduxState,
}) => {
  const bigDataRealtimeUpdateMillis = reduxState.summary.get('bigDataRealtimeUpdateMillis');
  const activeGranularity = realTimeGranularity || (enableTenMinuteTrend ? '10m' : '1h');
  const isTenMinActive = !!enableTenMinuteTrend && activeGranularity === '10m';

  return (
    <Translation>
      {
        (t, {i18n}) =>
        <div className={style.data_type_box} style={{ display: 'flex', alignItems: 'center' }}>
          <span className={style.data_type} style={{ paddingRight: '4px', display: 'inline-flex', alignItems: 'center', lineHeight: '22px' }}>{ t("DATATYPESELECT.dimension") }</span>
          <Tooltip arrow={true}
            placement="topLeft"
            align={{ offset: [-17, 0] }}
            overlayStyle={{ maxWidth: '30vw'}}
            title={(
              <div>
                <p style={{ marginBottom: 2, fontSize: '12px' }}>{ze(
                  '小时级崩溃率和累计崩溃率之间的大小没有必然联系，原因如下：',
                  'The hourly crash rate and daily crash rate are not necessarily related for the following reason:'
                )}</p>
                <p style={{ marginBottom: 2, fontSize: '12px' }}>{ ix(ze('崩溃率 = 崩溃设备去重 / 活跃设备去重', 'Rate calculation = count(affected devices) / count(active devices). ')) }</p>
                <p style={{ marginBottom: 2, fontSize: '12px' }}>{ ze('例如：', 'For example:') }</p>
                <p style={{ marginBottom: 2, fontSize: '12px' }}>{ix(ze(
                  '1、小时崩溃率 < 累计崩溃率。假设总共100个活跃用户， 每小时都在线。 前10个小时每小时崩溃一个设备（不同小时崩溃设备不一样） ，小时级崩溃率为1% ，累计崩溃率为10%。',
                  '1. Hourly crash rate < daily crash rate. Assuming there are a total of 100 active devices, and all of them are active every hour. In the first 10 hours, one device crashes per hour (different devices crash in different hours), so the hourly crash rate is 1% and the daily crash rate is 10%.'
                ))}</p>
                <p style={{ marginBottom: 2, fontSize: '12px' }}>{ix(ze(
                  '2、小时崩溃率 > 累计崩溃率。假设总共100个活跃用户， 每小时都10个用户在线。 前10个小时每小时崩溃一个设备（不同小时同一个设备一样） ，小时级崩溃率为10% ，累计崩溃率为1%。',
                  '2. Hourly crash rate > daily crash rate. Assuming there are a total of 100 active devices, and 10 users are active every hour. In the first 10 hours, one device crashes per hour (the same device crashes in different hours), so the hourly crash rate is 10% and the daily crash rate is 1%. '
                ))}</p>
                <p style={{ marginBottom: 2, fontSize: '12px' }}>{ix(ze(
                  '在大多数情况，小时级崩溃率会小于累计崩溃率。',
                  'In most cases, the hourly crash rate is smaller than the daily crash rate.'
                ))}</p>
              </div>
              )}>
            <span style={{ display: 'inline-flex', alignItems: 'center' }}><WrappedTipsIcon /></span>
          </Tooltip>
          {/* <span style={{ marginRight: '15px' }}>{ ze('：', ':')}</span> */}
          <Radio.Group
            style={{ marginLeft: '8px', display: 'inline-flex', alignItems: 'center' }}
            size="small"
            value={searchParams.get('dataType')}
            onChange={(value) => { console.log('change'); handleDataTypeChange(value); }}
          >
            <Radio value='hourly' style={{ display: 'inline-flex', alignItems: 'center', lineHeight: '22px', marginRight: 16 }}>{ isTenMinActive ? ze('每10分钟', 'Per 10 Min') : t("DATATYPESELECT.hour") }</Radio>
            <Radio value='appendly' style={{ display: 'inline-flex', alignItems: 'center', lineHeight: '22px' }}>{ t("DATATYPESELECT.total") }</Radio>
          </Radio.Group>
          { enableTenMinuteTrend && typeof handleGranularityChange === 'function' && (
            <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 16 }}>
              <span className={style.data_type} style={{ paddingRight: 8, display: 'inline-flex', alignItems: 'center', lineHeight: '22px' }}>{ ze('时间粒度', 'Granularity') }</span>
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: 2,
                borderRadius: 6,
                background: '#f2f3f5',
                border: '1px solid #e5e6eb',
              }}>
                {[
                  { key: '10m', label: ze('10分钟', '10 Min') },
                  { key: '1h', label: ze('1小时', '1 Hour') },
                ].map((opt) => {
                  const isActive = activeGranularity === opt.key;
                  return (
                    <button
                      key={opt.key}
                      type="button"
                      onClick={() => {
                        if (!isActive) {
                          handleGranularityChange(opt.key);
                        }
                      }}
                      style={{
                        border: 'none',
                        outline: 'none',
                        cursor: 'pointer',
                        padding: '2px 10px',
                        fontSize: 12,
                        lineHeight: '18px',
                        borderRadius: 4,
                        fontWeight: isActive ? 500 : 400,
                        color: isActive ? '#3470ff' : '#4e5969',
                        background: isActive ? '#ffffff' : 'transparent',
                        boxShadow: isActive ? '0 1px 2px rgba(0, 0, 0, 0.08)' : 'none',
                        transition: 'all 0.15s ease',
                      }}
                    >
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      }
    </Translation>
  );
};

const mapStateToProps = (state, router) => ({
  reduxState: state,
});

DataTypeSelect.propTypes = {
  handleDataTypeChange: PropTypes.func,
  handleGranularityChange: PropTypes.func,
  enableTenMinuteTrend: PropTypes.bool,
  realTimeGranularity: PropTypes.string,
  searchParams: PropTypes.object,
  reduxState: PropTypes.object,
};

export default connect(mapStateToProps)(DataTypeSelect);
